import { Component } from '@angular/core';
import {ParamBaseComponent} from "../../../../bases/param-base-component";
import {ComponentType} from "@angular/cdk/overlay";
import {MetricsDimensionsPickerComponent} from "../../../metrics-dimensions-picker/metrics-dimensions-picker.component";
import {Observable} from 'rxjs';
import {DimensionComponentObject, DimensionComponentObjects} from '../../../../classes/dimension-component-object';
import {selectDimensionComponentObjects, selectDimensionSourceGroups} from '../../../../store/selectors';
import {DatasetDimensionsGroupComponentObjects} from '../../../../classes/dataset-dimensions-group-component-object';
import {selectDataSetDimensionsGroupComponentObjects} from '../../../../store/dataSetDimensionsGroups/dataSetDimensionsGroups.selectors';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-param-dimensions',
  templateUrl: './report-param-dimensions.component.html',
  styleUrls: ['./report-param-dimensions.component.scss']
})
export class ReportParamDimensionsComponent extends ParamBaseComponent {
  public readonly component: ComponentType<MetricsDimensionsPickerComponent> = MetricsDimensionsPickerComponent;

  public readonly options$: Observable<DimensionComponentObjects> = this._store.select(this.paramDef.data || selectDimensionComponentObjects);
  public readonly categories$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDataSetDimensionsGroupComponentObjects);
  public readonly sources$: Observable<DatasetDimensionsGroupComponentObjects> = this._store.select(selectDimensionSourceGroups);

  public readonly disabledValues$: Observable<DimensionComponentObjects> = this._reportStore.disabledValues$.pipe(
    map((disabledValues: { [key: string]: any }): Array<DimensionComponentObject> => disabledValues[this.paramDef.controlName] || [])
  );
}
